import { useHistory, useLocation } from 'react-router-dom';
import { useKimLhc } from '@/context/KimLhc';
import { useCreateKimLhcReport } from '@/hooks/useCreateKimLhcReport';
import { useUpdateKimLhcReport } from '@/hooks/useUpdateKimLhcReport';
import { useUpdateStepAndCommentKimLhcReport } from '@/hooks/useUpdateStepAndCommentKimLhcReport';

interface CreateKimLhcParams {
	file_id: string;
	workstation_id: string;
	line_id: string;
	sector_id: string;
	company_id: string;
	organization_id: string;
	activity_id: string;
	evaluator_id: string;
	day_duration: number;
	activity_duration: number;
	collect_date: string;
	step: number;
}

interface UpdateKimLhcParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	workstation_id: string;
	line_id: string;
	sector_id: string;
	activity_id: string;
	evaluator_id: string;
	day_duration: number;
	activity_duration: number;
	collect_date: string;
	step?: number;
}

interface UpdateStepAndCommentKimLhcParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	step?: number;
	comment?: string;
}
export function useHandleActions() {
	const history = useHistory();
	const location = useLocation();
	const { onNextStep, onSetReportId } = useKimLhc();

	const { mutateAsync: createKimLhcReport, isLoading: isLoadingCreate } = useCreateKimLhcReport();
	const { mutateAsync: updateKimLhcReport, isLoading: isLoadingUpdate } = useUpdateKimLhcReport();
	const { mutateAsync: updateStepAndCommentKimLhcReport, isLoading: isLoadingUpdateStepAndComment } =
		useUpdateStepAndCommentKimLhcReport();

	async function handleCreateKimLhcReport(params: CreateKimLhcParams): Promise<void> {
		const response = await createKimLhcReport(params);
		const searchParams = new URLSearchParams(location.search);

		searchParams.set('report_id', response.id);
		history.push(`${location.pathname}?${searchParams.toString()}`);

		onSetReportId(response.id);

		onNextStep();
	}

	async function handleUpdateKimLhcReport(params: UpdateKimLhcParams): Promise<void> {
		await updateKimLhcReport(params);
		onNextStep();
	}

	async function handleUpdateStepAndCommentKimLhcReport(params: UpdateStepAndCommentKimLhcParams): Promise<void> {
		await updateStepAndCommentKimLhcReport(params);
	}

	return {
		handleCreateKimLhcReport,
		handleUpdateKimLhcReport,
		handleUpdateStepAndCommentKimLhcReport,
		isLoading: isLoadingCreate || isLoadingUpdate || isLoadingUpdateStepAndComment
	};
}
